import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import JornadaPage from "../pages/jornada/page";
import PreAnamnese from "../pages/pre-anamnese/page";
import LGPDPage from "../pages/lgpd/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/jornada",
    element: <JornadaPage />,
  },
  {
    path: "/pre-anamnese",
    element: <PreAnamnese />,
  },
  {
    path: "/lgpd",
    element: <LGPDPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
